import { Link } from 'react-router-dom';

export default function ClosingSection() {
  return (
    <section id="closing" className="py-16 md:py-20 bg-gradient-to-br from-blue-600 to-indigo-700">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6">
          安心して「パタカラ®」をご活用ください
        </h2>

        <p className="text-base text-white/90 leading-relaxed mb-10">
          公式施設ライセンス、自治体・官公庁等による非営利利用、現在使用しているサービス、WEBサイトまたは印刷物の取り扱いなど、ご不明な点がございましたらお気軽にお問い合わせください。
        </p>
        <p className="text-sm text-white/80 leading-relaxed mb-10">
          また、許諾のない利用と思われる施設サービス、WEBサイト、広告、配布物等に関する情報も受け付けています。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <Link
            to="/license-application"
            className="px-8 py-3 bg-white text-blue-600 font-semibold rounded-full hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            公式施設ライセンスを申し込む
          </Link>
          <a
            href="/contact"
            className="px-8 py-3 border-2 border-white text-white font-semibold rounded-full hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            お問い合わせ・情報提供
          </a>
        </div>

        <div className="border-t border-white/20 pt-8">
          <p className="text-sm text-white/80 font-medium">株式会社パックスシステムズ</p>
          <p className="text-xs text-white/60 mt-2">
            「パタカラ®」は株式会社パックスシステムズの登録商標です。
          </p>
        </div>
      </div>
    </section>
  );
}